import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AgentService from "services/agentService";
import axios from "axios";
import { API_URL } from "constants/ApiUrl";
// import { message } from "antd";

export const getProfile = createAsyncThunk(
  "agent/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AgentService.getProfile();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getConversations = createAsyncThunk(
  'conversations/get',
  async (id, { rejectWithValue }) => {
    try {
      const response = await AgentService.getConversations(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateProfile = createAsyncThunk(
  "agent/updateProfile",
  async (profileData, thunkAPI) => {
    try {
      const resp = await axios.put(`${API_URL}/api/agent/profile`, profileData);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const sendAgentMessage = createAsyncThunk(
  "agent/sendMessage",
  async (payload, { rejectWithValue }) => {
    const jwtToken = localStorage.getItem("authUser") || null;

    try {
      const response = await fetch(`${API_URL}/api/messages/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}),
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || "Une erreur s'est produite");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Erreur de réseau");
    }
  }
);

const PLAYER_TO_CHAT_KEY = "playerToChat";
const initialState = {
  agent: null,
  success: null,
  conversations: [],
  loading: false,
  error: null,
  messageSent: null,
  PlayerToChat: JSON.parse(localStorage.getItem(PLAYER_TO_CHAT_KEY)) || null,
  // message: null,
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setPlayerToChat(state, action) {
      state.PlayerToChat = action.payload;
      localStorage.setItem(PLAYER_TO_CHAT_KEY, JSON.stringify(action.payload));
    },
    clearPlayerToChat(state) {
      state.PlayerToChat = null;
      localStorage.removeItem(PLAYER_TO_CHAT_KEY);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.agent = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(getConversations.pending, (state) => {
        state.success = null
        state.error = null
        state.loading = true
      })
      .addCase(getConversations.fulfilled, (state, action) => {
        state.conversations = action.payload
        state.loading = false
      })
      .addCase(getConversations.rejected, (state, action) => {
        state.error = action.payload
        state.loading = false
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.agent = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(sendAgentMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendAgentMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.messageSent = action.payload;
        console.log(action.payload);
        // state.message = action.payload;
      })
      .addCase(sendAgentMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    //   .addCase(updateProfile.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(updateProfile.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.profile = action.payload;
    //   })
    //   .addCase(updateProfile.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload || action.error.message;
    //   });
  },
});
export const { setPlayerToChat, clearPlayerToChat } = agentSlice.actions;
export default agentSlice.reducer;
